
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recuperar-senha",
      function () {
        return require("private-next-pages/recuperar-senha/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recuperar-senha"])
      });
    }
  